module.exports = __webpack_public_path__ + "static/media/fight-team-1.7017bbcb.jpg";